import './AssistaVideo.css';

function AssistaVideo() {
  return (
    <div id="AssistaVideo" className="AssistaVideoContainer">
        <div className="AssistaVideoLeft">
            <div className="AssistaVideoTop">
                Assista o vídeo e entenda como funciona a Sofie.
            </div>
            <a href="https://play.google.com/store/apps/details?id=com.sofie.sofier&hl=pt_BR&utm_source=lp-sofie&utm_campaign=video&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                <img width="200px" alt="Disponível no Google Play" src="https://play.google.com/intl/pt-BR/badges/static/images/badges/pt_badge_web_generic.png" />
            </a>
        </div>
        <div className="AssistaVideoRight">
            <a
                // class="popup-video mfp-iframe"
                href="https://www.youtube.com/watch?v=pgLzUoKFqKc"
            >
                <svg width="30" height="30" viewBox="0 0 78 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.2942 1.89622C6.54083 -2.55123 0.254883 1.09217 0.254883 10.0275V75.9662C0.254883 84.9104 6.54083 88.5491 14.2942 84.1059L71.9279 51.0533C79.684 46.6043 79.684 39.3962 71.9279 34.9482L14.2942 1.89622Z" fill="currentColor"/>
                </svg>
            </a>
        </div>
    </div>
  );
}

export default AssistaVideo;
